__turbopack_context__.v({
  "component": "style-module-scss-module__19jb8G__component",
  "crea-logo": "style-module-scss-module__19jb8G__crea-logo",
  "mls-logo": "style-module-scss-module__19jb8G__mls-logo",
  "provider-logo": "style-module-scss-module__19jb8G__provider-logo",
  "realtor-logo": "style-module-scss-module__19jb8G__realtor-logo",
});
